// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmprogresspg-inline-1 {
  text-align: center;
  padding: 60px 20px;
}

.pmprogresspg-inline-2 {
  margin: 0 auto 20px;
}

.pmprogresspg-inline-3 {
  font-size: 14px;
  color: #64748b;
}

.pmprogresspg-inline-4 {
  text-align: center;
  padding: 40px;
}

.pmprogresspg-inline-5 {
  font-size: 14px;
  color: #64748b;
}

.pmprogresspg-inline-6 {
  margin-bottom: 14px;
}

.pmprogresspg-inline-7 {
  background: #f8fafc;
}

.pmprogresspg-inline-8 {
  display: flex;
  gap: 24px;
}

.pmprogresspg-inline-9 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-10 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-11 {
  font-size: 16px;
  font-weight: 700;
}

.pmprogresspg-inline-12 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-13 {
  font-size: 16px;
  font-weight: 700;
}

.pmprogresspg-inline-14 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-15 {
  font-size: 14px;
  font-weight: 600;
}

.pmprogresspg-inline-16 {
  padding: 0;
  overflow-x: auto;
}

.pmprogresspg-inline-17 {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
}

.pmprogresspg-inline-18 {
  font-weight: 600;
}

.pmprogresspg-inline-19 {
  font-family: monospace;
  font-size: 11px;
}

.pmprogresspg-inline-20 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pmprogresspg-inline-21 {
  width: 60px;
  height: 5px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.pmprogresspg-inline-22 {
  font-size: 11px;
  font-weight: 600;
}

.pmprogresspg-inline-23 {
  font-size: 11px;
  color: #475569;
}

.pmprogresspg-inline-24 {
  font-size: 10px;
  color: #94a3b8;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pmprogresspg-inline-25 {
  display: flex;
  gap: 4px;
}

.pmprogresspg-inline-26 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmprogresspg-inline-27 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmprogresspg-inline-28 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmprogresspg-inline-29 {
  padding: 0;
}

.pmprogresspg-inline-30 {
  font-weight: 600;
}

.pmprogresspg-inline-31 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.pmprogresspg-inline-32 {
  font-size: 13px;
  font-weight: 600;
}

.pmprogresspg-inline-33 {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}

.pmprogresspg-inline-34 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprogresspg-inline-35 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.pmprogresspg-inline-36 {
  font-size: 13px;
  font-weight: 600;
}

.pmprogresspg-inline-37 {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}

.pmprogresspg-inline-38 {
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 6px;
}

.pmprogresspg-inline-39 {
  font-weight: 600;
}

.pmprogresspg-inline-40 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprogresspg-inline-41 {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pmprogresspg-inline-42 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pmprogresspg-inline-43 {
  font-size: 13px;
  font-weight: 600;
}

.pmprogresspg-inline-44 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-45 {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
}

.pmprogresspg-inline-46 {
  font-size: 32px;
  margin-bottom: 12px;
}

.pmprogresspg-inline-47 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.pmprogresspg-inline-48 {
  font-size: 12px;
}

.pmprogresspg-inline-49 {
  max-height: 400px;
  overflow-y: auto;
}

.pmprogresspg-inline-50 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.pmprogresspg-inline-51 {
  font-size: 12px;
  font-weight: 600;
  color: #4338ca;
}

.pmprogresspg-inline-52 {
  font-size: 11px;
  color: #64748b;
}

.pmprogresspg-inline-53 {
  font-size: 12px;
  line-height: 1.6;
  color: #0f172a;
}

.pmprogresspg-inline-54 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprogresspg-dyn-1 {
  height: 100%;
  width: var(--pmprogresspg-1-width);
  background: var(--pmprogresspg-1-background);
  border-radius: 4px;
}

.pmprogresspg-dyn-2 {
  background: var(--pmprogresspg-2-background);
  color: var(--pmprogresspg-2-color);
  border-color: var(--pmprogresspg-2-border-color);
}

.pmprogresspg-dyn-3 {
  background: var(--pmprogresspg-3-background);
  color: var(--pmprogresspg-3-color);
}

.pmprogresspg-dyn-4 {
  padding: 16px;
  border-bottom: var(--pmprogresspg-4-border-bottom);
  background: var(--pmprogresspg-4-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMProgressPg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,4CAA4C;AAC9C","sourcesContent":[".pmprogresspg-inline-1 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmprogresspg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.pmprogresspg-inline-3 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-4 {\n  text-align: center;\n  padding: 40px;\n}\n\n.pmprogresspg-inline-5 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-6 {\n  margin-bottom: 14px;\n}\n\n.pmprogresspg-inline-7 {\n  background: #f8fafc;\n}\n\n.pmprogresspg-inline-8 {\n  display: flex;\n  gap: 24px;\n}\n\n.pmprogresspg-inline-9 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-10 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-11 {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.pmprogresspg-inline-12 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-13 {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.pmprogresspg-inline-14 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-15 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-16 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmprogresspg-inline-17 {\n  text-align: center;\n  padding: 24px;\n  color: #94a3b8;\n}\n\n.pmprogresspg-inline-18 {\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-19 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmprogresspg-inline-20 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pmprogresspg-inline-21 {\n  width: 60px;\n  height: 5px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.pmprogresspg-inline-22 {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-23 {\n  font-size: 11px;\n  color: #475569;\n}\n\n.pmprogresspg-inline-24 {\n  font-size: 10px;\n  color: #94a3b8;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pmprogresspg-inline-25 {\n  display: flex;\n  gap: 4px;\n}\n\n.pmprogresspg-inline-26 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmprogresspg-inline-27 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmprogresspg-inline-28 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmprogresspg-inline-29 {\n  padding: 0;\n}\n\n.pmprogresspg-inline-30 {\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-31 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.pmprogresspg-inline-32 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-33 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.pmprogresspg-inline-34 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprogresspg-inline-35 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.pmprogresspg-inline-36 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-37 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.pmprogresspg-inline-38 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #f1f5f9;\n  border-radius: 6px;\n}\n\n.pmprogresspg-inline-39 {\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-40 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprogresspg-inline-41 {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n}\n\n.pmprogresspg-inline-42 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pmprogresspg-inline-43 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprogresspg-inline-44 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-45 {\n  text-align: center;\n  padding: 40px;\n  color: #94a3b8;\n}\n\n.pmprogresspg-inline-46 {\n  font-size: 32px;\n  margin-bottom: 12px;\n}\n\n.pmprogresspg-inline-47 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.pmprogresspg-inline-48 {\n  font-size: 12px;\n}\n\n.pmprogresspg-inline-49 {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.pmprogresspg-inline-50 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.pmprogresspg-inline-51 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4338ca;\n}\n\n.pmprogresspg-inline-52 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprogresspg-inline-53 {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #0f172a;\n}\n\n.pmprogresspg-inline-54 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprogresspg-dyn-1 {\n  height: 100%;\n  width: var(--pmprogresspg-1-width);\n  background: var(--pmprogresspg-1-background);\n  border-radius: 4px;\n}\n\n.pmprogresspg-dyn-2 {\n  background: var(--pmprogresspg-2-background);\n  color: var(--pmprogresspg-2-color);\n  border-color: var(--pmprogresspg-2-border-color);\n}\n\n.pmprogresspg-dyn-3 {\n  background: var(--pmprogresspg-3-background);\n  color: var(--pmprogresspg-3-color);\n}\n\n.pmprogresspg-dyn-4 {\n  padding: 16px;\n  border-bottom: var(--pmprogresspg-4-border-bottom);\n  background: var(--pmprogresspg-4-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
